import type { Preview3DConfig } from './preview3d'

export const PREVIEW_MATERIAL_ALU_DIBOND: Partial<Preview3DConfig> = {
  defaultMaterialMode: 'alu',
  defaultShowFrame: false,
}

